module.exports = __webpack_public_path__ + "img/logo-circle.c0954b7a.png";